
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12 24C5.373 24 0 18.627 0 12S5.373 0 12 0s12 5.373 12 12-5.373 12-12 12zm-.02-7.585c3.403 0 6.162-2.227 6.162-4.975 0-2.748-2.759-4.976-6.162-4.976-3.404 0-6.163 2.228-6.163 4.976 0 1.678 1.03 3.163 2.607 4.064l.04.023c.02.011.035.03.04.054.136.648-.752 1.23-1.345 1.617 1.966.124 2.958-.663 3.242-.921a8.36 8.36 0 001.579.138z","fill":"#EFEFF4"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M11.98 16.415c3.403 0 6.162-2.227 6.162-4.975 0-2.748-2.759-4.976-6.162-4.976-3.404 0-6.163 2.228-6.163 4.976 0 1.678 1.03 3.163 2.607 4.064l.04.023c.02.011.035.03.04.054.135.648-.752 1.23-1.345 1.617 1.966.124 2.958-.663 3.242-.921.48.097 1.06.138 1.579.138z","fill":"#007AFF"}})])
          )
        }
      }
    